const normalizeText = (...values) =>
  values
    .filter(Boolean)
    .map((value) => String(value).trim().toLowerCase())
    .filter(Boolean)
    .join(' ');

const getCourseById = (courses = [], courseId) =>
  courses.find((course) => course.id === courseId) || null;

export const isBuildingFamilyEconomyCourse = (courses = [], courseId, intake = '') => {
  if (!courseId && !intake) return false;
  const course = getCourseById(courses, courseId);
  const title = normalizeText(course?.title, course?.intake, intake);
  return title.includes('building a family economy');
};

export const isMillionairesConnectCourse = (courses = [], courseId, intake = '') => {
  if (!courseId && !intake) return false;
  const course = getCourseById(courses, courseId);
  const title = normalizeText(course?.title, course?.intake, intake);
  return title.includes('millionaires connect');
};

export const resolveCourseGroup = (courses = [], courseId, intake = '') => {
  if (!courseId && !intake) return 'general';
  const course = getCourseById(courses, courseId);
  const title = normalizeText(course?.title, course?.intake, intake);
  if (title.includes('masters of the economy')) {
    return 'masters_of_the_economy';
  }
  return courseId || intake || 'general';
};

export const getResourceCourseLabel = (courses = [], resource = {}) => {
  const course = courses.find(
    (item) => item.id === resource.courseId || (resource.intake && item.intake === resource.intake)
  );
  return course?.title || resource.intake || 'General';
};

export const resourceMatchesActiveCourse = ({
  resource,
  courses = [],
  activeCourseId,
  activeIntake
}) => {
  if (!resource) return false;
  if (isBuildingFamilyEconomyCourse(courses, activeCourseId, activeIntake)) {
    return false;
  }

  const activeCourseGroup = resolveCourseGroup(courses, activeCourseId, activeIntake);
  const activeIsMillionairesConnect = isMillionairesConnectCourse(courses, activeCourseId, activeIntake);
  const resourceCourse = getCourseById(courses, resource.courseId);
  const resourceText = normalizeText(
    resource.title,
    resource.module,
    resource.category,
    resource.description,
    resource.intake,
    resourceCourse?.title,
    resourceCourse?.intake
  );

  if (activeIsMillionairesConnect) {
    if (resourceText.includes('millionaires connect')) {
      return true;
    }
    if (resource.courseId) {
      return resolveCourseGroup(courses, resource.courseId, resource.intake) === activeCourseGroup;
    }
    return false;
  }

  if (resource.courseId) {
    if (!activeCourseId) return false;
    return resolveCourseGroup(courses, resource.courseId, resource.intake) === activeCourseGroup;
  }

  if (resource.intake) {
    if (!activeIntake) return false;
    return String(resource.intake).trim().toLowerCase() === String(activeIntake).trim().toLowerCase();
  }

  return !activeCourseId && !activeIntake;
};
